/**
 * @flow
 * @relayHash 9b1e96f4d09b98b8a78153b74cde73bc
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type StreamEditInput = {
  id: string,
  title: string,
  description?: ?string,
  topics?: ?$ReadOnlyArray<?string>,
  video?: ?string,
  availableAt?: ?string,
  active?: ?boolean,
  screen?: ?boolean,
  rating?: ?string,
  state?: ?string,
  linkedArticles?: ?$ReadOnlyArray<?string>,
  videoFile?: ?string,
  preview?: ?string,
  clientMutationId?: ?string,
};
export type StreamEditMutationVariables = {|
  input: StreamEditInput
|};
export type StreamEditMutationResponse = {|
  +StreamEdit: ?{|
    +stream: ?{|
      +id: string
    |}
  |}
|};
export type StreamEditMutation = {|
  variables: StreamEditMutationVariables,
  response: StreamEditMutationResponse,
|};
*/


/*
mutation StreamEditMutation(
  $input: StreamEditInput!
) {
  StreamEdit(input: $input) {
    stream {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "StreamEditInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "StreamEdit",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "StreamEditInput!"
      }
    ],
    "concreteType": "StreamEditPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "stream",
        "storageKey": null,
        "args": null,
        "concreteType": "Stream",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "StreamEditMutation",
  "id": null,
  "text": "mutation StreamEditMutation(\n  $input: StreamEditInput!\n) {\n  StreamEdit(input: $input) {\n    stream {\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "StreamEditMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "StreamEditMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '60b97c766040d7de75399ef189e45a12';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/StreamEditMutation.graphql.js